require("./src/styles/global.scss");

exports.onInitialClientRender = () => {
};

exports.wrapRootElement = ({ element }) => {
  return element;
};
